import styled from 'styled-components';
import { Dot, Box } from '@comeon/ui';

const Wrapper = styled(Box).attrs({ p: 6 })`
	display: flex;
	justify-content: center;
	& > button {
		margin-right: 8px;
	}
`;

const NavigationDots = ({ length = 0, activeIndex = 0 }) => {
	const navigationDotsList = Array(length)
		.fill(1)
		.map((value, index) => index * value);

	return (
		<Wrapper data-at="navigation-dots">
			{navigationDotsList.map(i => (
				<Dot key={i} active={i === activeIndex} data-at="navigation-dots-dot" />
			))}
		</Wrapper>
	);
};

export default NavigationDots;
